import { AsyncResp, requestPapi } from '@paradigm/api/src/fetch-api';
import { processUMPlatformState } from '@paradigm/api/src/process/platform-state';
import { PlatformState, RawPlatformState } from '@paradigm/api/types';
import { getGrfqBaseUrl } from './grfq-api';

export async function getGrfqPlatformState(): AsyncResp<PlatformState> {
  const resp = await requestPapi<RawPlatformState>({
    method: 'GET',
    url: `${getGrfqBaseUrl()}/platform_state/`,
  });

  if (!resp.ok) return resp;

  return { ...resp, data: processUMPlatformState(resp.data) };
}

export async function getDrfqPlatformState(): AsyncResp<PlatformState> {
  const resp = await requestPapi<RawPlatformState>({
    method: 'GET',
    url: `/v2/drfq/platform_state/`,
  });

  if (!resp.ok) return resp;

  return { ...resp, data: processUMPlatformState(resp.data) };
}
